import { cn } from '@/lib';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
    return (
        <div data-slot='skeleton' className={cn('bg-neutral-subtle animate-pulse rounded-md', className)} {...props} />
    );
}

export { Skeleton };
